export default __webpack_public_path__ + "static/media/Christ_at_the_Cross_-_Cristo_en_la_Cruz.49521f5a.jpg";